import { ChangeStatusEnum } from '@docma-mm-core/model/change-state/change-status.enum';
import { LoadState } from '@docma-mm-core/model/load-state/load-state';
import { LoadStatusEnum } from '@docma-mm-core/model/load-state/load-state.enum';
import { blobToArrayBuffer } from '@mydocma/common/src/lib/file';
import { Attachment } from './attachment';
import {Group} from '@docma-mm-core/group/group';

export class AttachmentFileDbEntity {
  loadState: LoadState<FileDbEntity>;
  status: ChangeStatusEnum;
  uid: string;
  faultUid: string;
  groupUid: string;
}

export interface FileDbEntity {
  uid?: string;
  name: string;
  mimeType: string;
  buffer: ArrayBuffer;
}


export const mapAttachmentSourceToEntity = async (faultUid: string, groupUid: string, attachment: Attachment): Promise<AttachmentFileDbEntity> => {
  const entity =  new AttachmentFileDbEntity();
  entity.faultUid = (!groupUid ? faultUid : null);
  entity.groupUid = groupUid;
  entity.uid = attachment.uid;
  entity.status = attachment.changeState.status;
  if (attachment.source.loadState.status === LoadStatusEnum.NotLoaded || attachment.source.loadState.status === LoadStatusEnum.Loading) {
    return null;
  } else if (attachment.source.loadState.status === LoadStatusEnum.Error) {
    entity.loadState = new LoadState({
      status: LoadStatusEnum.Error,
      date: attachment.source.loadState.date
    });
  } else {
    const fileEntity: FileDbEntity = {
      buffer:  await blobToArrayBuffer(attachment.source.loadState.data),
      name: attachment.data.FileName,
      mimeType: attachment.data.MimeType,
    };

    entity.loadState = new LoadState({
       status: attachment.source.loadState.status,
       data: fileEntity,
       date: attachment.source.loadState.date
     });
  }
  return entity;
};

export const mapGroupAttachmentSourceToEntity = async (group: Group, attachment: Attachment ): Promise<AttachmentFileDbEntity> => {
  const entity =  new AttachmentFileDbEntity();
  entity.groupUid = group.uid;
  entity.uid = attachment.uid;
  entity.status = attachment.changeState.status;
  if (attachment.source.loadState.status === LoadStatusEnum.NotLoaded || attachment.source.loadState.status === LoadStatusEnum.Loading) {
    return null;
  } else if (attachment.source.loadState.status === LoadStatusEnum.Error) {
    entity.loadState = new LoadState({
      status: LoadStatusEnum.Error,
      date: attachment.source.loadState.date
    });
  } else {
    const fileEntity: FileDbEntity = {
      buffer:  await blobToArrayBuffer(attachment.source.loadState.data),
      name: attachment.data.FileName,
      mimeType: attachment.data.MimeType,
    };

    entity.loadState = new LoadState({
      status: attachment.source.loadState.status,
      data: fileEntity,
      date: attachment.source.loadState.date
    });
  }
  return entity;
};

export const mapFileEntityToFile = (entity: FileDbEntity): File => {

  if (!entity.buffer) {
    return null;
  }
  const file = new File([entity.buffer], entity.name, {type: entity.mimeType});
  return file;
};
